import { render, staticRenderFns } from "./DateValue.vue?vue&type=template&id=0705841c&scoped=true&"
import script from "./DateValue.vue?vue&type=script&lang=js&"
export * from "./DateValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705841c",
  null
  
)

export default component.exports